import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Chip,
} from "@mui/material";
import "./limit.scss";
import Label from "../../../components/Label/Label";
import { useState } from "react";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
}) {
  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        className="audit-table-container"
        sx={{ scrollbarGutter: "auto" }}
      >
        <Table stickyHeader sx={{ tableLayout: "auto", width: "100%" }}>
          <TableHead positon="sticky" top={0} className="table-header">
            <TableRow>
              <TableCell className="audit-table-header-cell">
                Event Name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Parameter name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Limit type
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Set name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Field name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Previous Value
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Current Value
              </TableCell>

              <TableCell className="audit-table-header-cell">
                Updated status
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated by{" "}
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated on
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {
              // openData &&

              data?.data?.results?.map((row) => (
                <>
                  <TableRow key={row.audit_id}>
                    <TableCell>{row.action}</TableCell>
                    <TableCell>{row.parameter_name}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.limit_type}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.set_name}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      {row.field_name}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14, paddingLeft: "18px" }}>
                      {row.field_name === "acceptable_value"
                        ? typeof row.previous_value === "string"
                          ? row.previous_value.replace(/[\[\]{}'"]/g, "") // remove [ ], { }, ' and "
                          : Array.isArray(row.previous_value)
                            ? row.previous_value.join(", ")
                            : row.previous_value &&
                                typeof row.previous_value === "object"
                              ? Object.keys(row.previous_value).join(", ")
                              : row.previous_value || ""
                        : row.previous_value}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14, paddingLeft: "18px" }}>
                      {row.field_name === "acceptable_value"
                        ? typeof row.updated_value === "string"
                          ? row.updated_value.replace(/[\[\]{}'"]/g, "")
                          : Array.isArray(row.updated_value)
                            ? row.updated_value.join(", ")
                            : row.updated_value &&
                                typeof row.updated_value === "object"
                              ? Object.keys(row.updated_value).join(", ")
                              : row.updated_value || ""
                        : row.updated_value}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14 }}>
                      <Chip
                        label={row.updated_status}
                        className={`status-chip ${
                          row.updated_status?.includes("Current")
                            ? "status-chip-color-green"
                            : "status-chip-color-gray"
                        }`}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: 14, paddingLeft: "18px" }}>
                      {row.updated_by}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14, paddingLeft: "18px" }}>
                      {row.updated_at}
                    </TableCell>
                  </TableRow>
                </>
              ))
            }
            {!data?.loader && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={tableHeaders?.length || 10} align="center">
                  <Label color="textSecondary" text={"No data found"}></Label>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
